<script setup>
import {useSystem} from "../../store/system";
import {onActivated, onMounted} from "vue";

const systemStore = useSystem()

const tempColors = []
const colorEqule = () => {
  if (tempColors.length % 2 === 0) {
    let color = systemStore.getRandomColor()
    tempColors.push("stats__dodger--" + color)
  }else{
    tempColors.push(tempColors[tempColors.length-1])
  }
  return tempColors[tempColors.length-1]
}

onMounted(() => {
  setTimeout(() => {
    // 动态雾霾效果
    if (document.querySelector('.section__canvas--first')) {
      VANTA.FOG({
        el: "#canvas2",
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.00,
        minWidth: 200.00,
        highlightColor: 0xA034FA,
        midtoneColor: 0xA034FA,
        lowlightColor: 0xE66C12,
        baseColor: 0x16142A,
        blurFactor: 0.90,
        speed: 5.70,
        zoom: 1.00
      })
    }

    // 动态雾霾效果
    if (document.querySelector('.section__canvas--second')) {
      VANTA.FOG({
        el: "#canvas3",
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.00,
        minWidth: 200.00,
        highlightColor: 0xA034FA,
        midtoneColor: 0xA034FA,
        lowlightColor: 0xE66C12,
        baseColor: 0x16142A,
        blurFactor: 0.90,
        speed: 5.70,
        zoom: 1.00
      })
    }
  }, 600)

  setTimeout(() => {
    if (document.querySelector('.roadmap__carousel')) {
      var elms = document.getElementsByClassName('roadmap__carousel');

      for ( var i = 0; i < elms.length; i++ ) {
        new Splide(elms[ i ], {
          type: 'loop',
          perPage: 3,
          drag: true,
          pagination: false,
          autoWidth: false,
          auto: true,
          speed: 800,
          gap: 10,
          arrows: false,
          focus: 0,
          breakpoints: {
            767: {
              pagination: true,
              arrows: false,
              perPage: 1,
            },
            991: {
              pagination: true,
              arrows: false,
              perPage: 2,
            },
            1199: {
              pagination: true,
              arrows: false,
              perPage: 3,
            },
          }
        }).mount();
      }
    }
  }, 1500)

})

onActivated(() => {
  document.title = 'About HexMiner | Trusted Crypto Cloud Mining Experts';
  document.querySelector('meta[name="description"]').setAttribute('content', 'About HexMiner | Trusted Crypto Cloud Mining Experts');
})
</script>

<template>
  <div>

    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12">
            <div class="section__title">
              <h1>{{systemStore.getFrontModuleContent(17)?.title}}</h1>
              <p>{{systemStore.getFrontModuleContent(17)?.sub_title}}</p>
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- statistics -->
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-6 col-xl-3" v-for="(item, index) in systemStore.getFrontModuleContent(17, 1)?.json_data" :key="index">
            <!-- stats -->
            <div class="stats">
              <span class="stats__value">{{item.title}}</span>
              <p class="stats__name">{{item.desc}}</p>

              <!-- design elements -->
              <span class="stats__dodger stats__dodger--left" :class="colorEqule()"></span>
              <span class="stats__dodger stats__dodger--right" :class="tempColors[tempColors.length-1]"></span>
            </div>
            <!-- end stats -->
          </div>
        </div>
      </div>
    </div>
    <!-- end statistics -->

    <!-- roadmap -->
    <section class="section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="roadmap">
              <h2 class="roadmap__title">{{systemStore.getFrontModuleContent(18).title}}</h2>

              <!-- carousel -->
              <div class="roadmap__carousel splide splide--roadmap">
                <div class="splide__arrows">
                  <button class="splide__arrow splide__arrow--prev" type="button"><i class="ti ti-arrow-left"></i></button>
                  <button class="splide__arrow splide__arrow--next" type="button"><i class="ti ti-arrow-right"></i></button>
                </div>

                <div class="splide__track">
                  <ul class="splide__list">

<!--                    <li class="splide__slide">-->
<!--                      &lt;!&ndash; step &ndash;&gt;-->
<!--                      <div class="roadmap__block roadmap__block&#45;&#45;active">-->
<!--                        <h3 class="roadmap__block-title">2024 Q1</h3>-->
<!--                        <ul class="roadmap__block-list">-->
<!--                          <li>Launch the beta version of the website for a limited user group to gather feedback.</li>-->
<!--                          <li>Test and optimize the trading algorithms to ensure accuracy and efficiency.</li>-->
<!--                          <li>Implement robust security measures, including encryption and two-factor authentication.</li>-->
<!--                        </ul>-->
<!--                      </div>-->
<!--                      &lt;!&ndash; end step &ndash;&gt;-->
<!--                    </li>-->

                    <li class="splide__slide" v-for="(item, index) in systemStore.getFrontModuleContent(18)?.json_data" :key="index">
                      <!-- step -->
                      <div class="roadmap__block roadmap__block--active">
                        <h3 class="roadmap__block-title">{{item.title}}</h3>
                        <ul class="roadmap__block-list">
                          <li>{{item.desc}}</li>
                        </ul>
                      </div>
                      <!-- end step -->
                    </li>
                  </ul>
                </div>
              </div>
              <!-- end carousel -->


              <!-- design elements -->
              <span class="block-icon block-icon--blue">
							<i class="ti ti-north-star"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- end roadmap -->

    <!-- company -->
    <section class="section">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12">
            <div class="company">
              <h2 class="company__title">{{systemStore.getFrontModuleContent(19).title}}</h2>

              <div class="row" v-if="systemStore.getFrontModuleContent(19)?.json_data">
                <div class="col-12 col-xl-7">
                  <p class="company__text">{{systemStore.getFrontModuleContent(19).description}}</p>
<!--                  <p class="company__text">{{ systemStore.getFrontModuleContent(19)?.json_data[1].title }} <b>{{ systemStore.getFrontModuleContent(19)?.json_data[1].desc }}</b></p>-->
                </div>

                <div class="col-12 col-xl-4 offset-xl-1">
                  <p class="company__subtitle">{{ systemStore.getFrontModuleContent(19)?.json_data[0].title }}</p>
                  <p class="company__text">{{ systemStore.getFrontModuleContent(19)?.json_data[0].desc }}</p>
                </div>
              </div>

              <!-- design elements -->
              <span class="block-icon block-icon--orange">
							<i class="ti ti-certificate-2"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>

          <!-- animation background -->
          <div class="section__canvas section__canvas--second" id="canvas3"></div>
        </div>
      </div>
    </section>
    <!-- end company -->

  </div>
</template>

<style scoped>

</style>
